<template>
  <div>
    <navbar />
    <router-view />
  </div>
</template>

<style lang="scss" scoped>
</style>

<script>
import Navbar from '@/components/Navbar'

export default {
  name: 'Layout',
  components: {
    Navbar,
  },
}
</script>
